import Organizations from "../components/Organizations/Organizations";
import {PERM} from "../utilites/permissions";

const organizations = [
  {
    path: '/organizations/:id(\\d+)?',
    name: 'Organizations',
    component: Organizations,
    meta: {
      requiresAuth: true,
      permissions: [
        PERM.ORGANIZATION,
      ]
    }
  },
];

export default organizations;



// WEBPACK FOOTER //
// ./src/router/organizations.js